import React, { useCallback } from 'react';
import { IconButton, Stack, TableCell } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyTextToClipboard } from "../../../../action/copyTextToClipboard";
import { NumberishId } from "../../../../model/type";

const MediumIdTableCell: React.FC<MediumIdTableCellProps> = props => {
    const onCopyMediumIdClick = useCallback(e => {
        e.stopPropagation();
        props.copyTextToClipboard(String(props.mediumId));
    }, [props.mediumId]);

    return (
        <TableCell>
            <Stack alignItems='flex-start'>
                <Stack direction='row' alignItems='center'>
                    <IconButton size='small' onClick={ onCopyMediumIdClick }>
                        <ContentCopyIcon fontSize='small'/>
                    </IconButton>
                    { props.mediumId }
                </Stack>
            </Stack>
        </TableCell>
    );
}
export default MediumIdTableCell;

export interface MediumIdTableCellProps {
    readonly copyTextToClipboard: CopyTextToClipboard;
    readonly mediumId: NumberishId;
}